import styled from "styled-components";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

import img1 from "../assets/academy/academ1.jpeg";
import img2 from "../assets/academy/academ2.jpeg";
import img3 from "../assets/academy/academ2.jpeg";
import img4 from "../assets/academy/acad4.webp";
import img5 from "../assets/academy/kombi.jpg";
import img6 from "../assets/academy/academ7.jpg";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

const PROGRAMS = [
  {
    id: "micro-needling",
    title: "Microneedling",
    desc: "In unserer Microneedling-Schulung lernst du, Hauttypen professionell zu analysieren und Nadeltiefe sowie Wirkstoffe gezielt einzusetzen, um Hautbilder wie Akne, Narben oder Zeichen der Hautalterung effektiv zu behandeln.",
    img: img1,
  },
  // {
  //   id: "lash-browlifting",
  //   title: "Lash & Browlifting",
  //   desc: "Fortgeschrittene Techniken für chemisches Lifting.",
  //   img: img2,
  // },
  {
    id: "aquafacial",
    title: "Aquafacial",
    desc: "Die Aquafacial-Schulung vermittelt dir strukturierte Abläufe für eine tiefenreinigende, hautverfeinernde Behandlung mit sichtbaren Ergebnissen.",
    img: img3,
  },
  // {
  //   id: "eye-lash-extension",
  //   title: "Wimpernverlängerung",
  //   desc: "Präzise Applikation von Volumentechniken.",
  //   img: img4,
  // },
  {
    id: "dermaplanning",
    title: "Kombischulung",
    desc: "Aquafacial & Microneedling",
    img: img5,
  },
  {
    id: "mediostar-laser",
    title: "Mediostar Laser",
    desc: "Qualität, Sicherheit und Verantwortung stehen bei der Arbeit mit Lasergeräten an erster Stelle.",
    img: img6,
  },
];

const Academy = () => {
  const container = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Academy - ERA AESTHETICS";
  }, []);

  useGSAP(
    () => {
      const cards = gsap.utils.toArray(".card");

      cards.forEach((card, index) => {
        if (index !== cards.length - 1) {
          const overlay = card.querySelector(".card-overlay");

          gsap.to(card, {
            scale: 0.95, // Subtle scale for depth
            scrollTrigger: {
              trigger: card,
              start: "top 10%",
              endTrigger: ".container",
              end: "bottom bottom",
              scrub: true,
            },
          });

          // Animate the overlay instead of card opacity to preserve backdrop-filter
          gsap.to(overlay, {
            opacity: 1,
            scrollTrigger: {
              trigger: card,
              start: "top 10%",
              endTrigger: ".container",
              end: "bottom bottom",
              scrub: true,
            },
          });
        }
      });
    },
    { scope: container },
  );

  return (
    <PageWrapper ref={container} className="container">
      <Header>
        <span className="label">Academy</span>
        <h1 className="h1">Dein Start in die Beauty-Branche</h1>
        <h1 className="h2">
          Dein Start <br /> in die <br /> Beauty-Branche
        </h1>
      </Header>

      <CardsContainer>
        {PROGRAMS.map((item, index) => (
          <CardWrapper key={item.id} className="card" $index={index}>
            <InnerCard>
              <CardOverlay className="card-overlay" />

              <TextSide>
                <span className="index">{item.title.replace("-", " ")}</span>
                <h2>{item.title}</h2>
                <p>{item.desc}</p>
                <Link to={`/academy/${item.id}`}>
                  <button className="details-btn">Details ansehen</button>
                </Link>
              </TextSide>
              <ImageSide>
                <img src={item.img} alt={item.title} />
              </ImageSide>
            </InnerCard>
          </CardWrapper>
        ))}
      </CardsContainer>

      <FooterSpacer />
    </PageWrapper>
  );
};

export default Academy;

// --- Styled Components ---

const MAIN_COLOR = "#5a5248";

const PageWrapper = styled.div`
  color: ${MAIN_COLOR};
  padding: 0 5%;
`;

const Header = styled.div`
  display: flex;
  margin: 8rem 0 3rem 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .label {
    text-transform: uppercase;
    letter-spacing: 0.5rem;
    font-size: 0.9rem;
    opacity: 0.6;
  }
  .h1 {
    font-family: "The Seasons", serif;
    font-size: clamp(3rem, 8vw, 6rem);
    font-weight: 400;
  }
  .h2 {
    display: none;
  }
  @media (max-width: 500px) {
    .h1 {
      font-size: 9vw;
      display: none;
    }
    .h2 {
      display: block;
      font-family: "The Seasons", serif;
      font-size: clamp(3rem, 8vw, 6rem);
      font-weight: 400;
    }
  }
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CardWrapper = styled.div`
  position: sticky;
  top: 10vh;
  width: 100%;
  max-width: 1700px;
  height: 75vh;
  margin-bottom: 15vh;
  display: flex;
  justify-content: center;
  z-index: ${(props) => props.$index};
  /* Perspective helps with the scaling visual */
  perspective: 1000px;
`;

const InnerCard = styled.div`
  position: relative; /* Essential for overlay */
  width: 100%;
  height: 100%;
  background: rgba(
    255,
    255,
    255,
    0.65
  ); /* Adjusted for better blur visibility */
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  overflow: hidden;

  /* The Magic Blur */
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);

  display: flex;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);

  ${CardWrapper}:nth-child(even) & {
    flex-direction: row-reverse;
  }

  @media (max-width: 768px) {
    flex-direction: column !important;
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(90, 82, 72, 0.15); /* Color matches your theme */
  opacity: 0;
  pointer-events: none;
  z-index: 2; /* Sits above text/image but below interactive elements if needed */
  transition: opacity 0.3s ease;
`;

const TextSide = styled.div`
  flex: 1;
  padding: 8%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 3;
  span {
    text-transform: lowercase;
  }

  .index {
    font-size: 0.8rem;
    opacity: 0.5;
    margin-bottom: 1rem;
    display: block;
  }
  h2 {
    font-family: "Playfair Display", serif;
    font-size: clamp(1.8rem, 4vw, 3.5rem);
    font-weight: 400;
    margin-bottom: 1.5rem;
  }
  p {
    font-size: 1.1rem;
    line-height: 1.6;
    opacity: 0.8;
    margin-bottom: 2rem;
  }
  .details-btn {
    background: none;
    border: none;
    border-bottom: 1px solid ${MAIN_COLOR};
    color: ${MAIN_COLOR};
    width: fit-content;
    padding: 5px 0;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    font-size: 0.75rem;
    cursor: pointer;
  }
`;

const ImageSide = styled.div`
  flex: 1.3;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const FooterSpacer = styled.div`
  height: 20vh;
`;
